import React from 'react';

import './player-card-badge.scss';
import { makeClassNames } from '../../../utils/styles';

const classNames = () =>
  makeClassNames({
    playerBadge: 'player-report-card__badge',
  });

export interface IPlayerCardBadge {
  label: string;
}

const PlayerCardBadge = (props: IPlayerCardBadge) => {
  const { label } = props;
  const cn = classNames();

  return <div className={cn.playerBadge}>{label}</div>;
};

export default PlayerCardBadge;
